/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Bank_Target_LabelInputs */

const vi_order_settlement_bank_target_label = /** @type {(inputs: Order_Settlement_Bank_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách chuyển vào`)
};

/**

* @param {Order_Settlement_Bank_Target_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_bank_target_label = /** @type {((inputs?: Order_Settlement_Bank_Target_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Bank_Target_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_bank_target_label(inputs)
});